import { isEnglish, language } from './locale';
export const text = (zh, en) => isEnglish ? en : zh;
export function languageUrl(src) {
  const [path, hash] = src.split('#');
  return path + (path.includes('?') ? '&' : '?') + 'lang=' + language + (hash ? '#' + hash : '');
}
const translations = {
  'orbit-84': {
    title: 'ORBIT-84 · Retro Terminal',
    summary: 'An isometric, line-art 1980s computer. Type on your keyboard or click the 3D keys to run commands, flip the side power switch for the CRT on/off animation, and insert the floppy to play Snake. Hidden extras include fireworks, Hello World and rolling credits on exit.',
    variants: [{name: 'Retro Terminal', desc: 'Keyboard input · Power switch · Floppy Snake · Easter eggs'}],
  },
  'pipa-rhythm': {
    title: 'Pipa Rhythm',
    summary: 'Step on up, down, left and right arrows to the 130 BPM beat of “Pipa Song (DJ Xiaoxuan remix)”. The backdrop is an ink-wash river flight, and every hit swings, lifts or dives the camera. Arrows fall from the top or rise from the bottom; keyboard and touch; interface in seven languages.',
    variants: [{name: 'Dance Arrows', desc: 'Easy · Normal · Hard / Keyboard and touch'}],
  },
  'temple-of-heaven': {
    title: 'Temple of Heaven',
    summary: 'Rotate, section and separate the Hall of Prayer’s three circular eaves, 28 columns and marble terraces. Explore its history, Li Qianlang’s drawings and records of Liang Sicheng’s conservation work. Viewer and archive in Chinese.',
    variants: [{name: 'Temple of Heaven Architectural Atlas', desc: 'Structure · Drawings · History and conservation'}],
  },
  'mirror-hand-tracking': {
    title: 'Mirror · Hand Tracking',
    summary: 'Explore hand tracking over live video, collect playful merit points by moving your hand into the area above your head and then out, or use the face-following tilt-shift mirror. Video is processed locally on your device.',
    variants: [{name: 'Hands & Mirror', desc: 'Live overlays · Hand skeleton · Tilt-shift mirror'}, {name: 'Merit +1', desc: 'Hand above your head · Move out · Merit +1'}],
  },
  'china-metro-spacetime': {
    title: 'Metro · Space & Time',
    summary: 'Explore the 3D networks of Beijing, Shanghai and Chongqing: stations, line colors, distances and surface elevations. Trace openings by year or month, and follow a 3D train through simulated rides, stops and transfers.',
    variants: [{name: 'Metro Atlas · Three Cities', desc: 'Beijing · Shanghai · Chongqing / Terrain and network history'}],
  },
  'beijing-city-evolution': {
    title: 'Beijing',
    summary: 'Trace Beijing from ancient Ji to the modern city across nine eras. Explore historic gates, terrain, rivers, lakes and parks, and compare the city with Liang Sicheng’s preservation proposals.',
    variants: [{name: 'Beijing · A City Through Time', desc: 'Urban evolution · City gates · Landscape and terrain'}],
  },
  'foguang-temple': {
    title: 'Foguang Temple',
    summary: 'Explore the East Hall’s column grid, timber frame, bracket sets and roof through architectural surveys. Compare historical drawings with photographs and examine the evidence and limits of the model.',
    variants: [{name: 'Foguang Temple Architectural Atlas', desc: 'East Hall · Timber structure · Drawings and photographs'}],
  },
  'yingxian-pagoda': {
    title: 'Yingxian Wooden Pagoda',
    summary: 'Drawing on Liang Sicheng’s surveys, explore a conceptual 3D model of five visible storeys, four concealed structural levels, column grids, timber frames and stairways, alongside historical drawings and photographs.',
    variants: [{name: 'Yingxian · Timber Atlas', desc: 'Structure · Stairs and circulation · Survey archive'}],
  },
  'rust-and-roam': {
    title: 'Rust & Roam',
    summary: 'A pixel-art idle road-trip game for the macOS desktop. Explore visual studies of old cars, travel, energy and cargo systems, with layered artwork for production.',
    variants: [{name: 'Portfolio', desc: 'Design evolution · Layered artwork · Parallax scenes'}],
  },
  'greenfell': {
    title: 'Greenfell at Dusk',
    summary: 'A landing-page study for a pixel-art farming and life simulation game inspired by Stardew Valley. Compare three visual directions using the same content.',
    variants: [
      {name: 'A · Cozy Sundown',desc: 'Warm dusk · Parchment tones · Farming-game influences'},
      {name: 'B · Twilight Glow',desc: 'JRPG twilight · Gold outlines · Atmospheric gradients'},
      {name: 'C · Arcade Cartridge',desc: 'Arcade cartridge · CRT neon · Scanlines'},
    ],
  },
};
export function translateProject(project) {
  if (!project || !isEnglish || !translations[project.id]) return project;
  const translated = translations[project.id];
  return {...project, ...translated, variants: project.variants.map((variant,i) => ({...variant,...translated.variants[i]}))};
}
